import {LocalStorageController} from './LocalStorageController';
import {Preferences} from '@capacitor/preferences';

export class IOSPreferenceStorageController implements LocalStorageController {
    add(storageName: string, value: any, keyName: string): Promise<string> {
        return new Promise(async (resolve) => {
            Preferences.set({
                key: storageName + '_' + keyName,
                value: JSON.stringify({val: value}),
            }).then(() => {
                resolve('success');
            });
        });
    }

    get<T>(storageName: string, keyName: string, defaultValue: T): Promise<T> {
        return new Promise<any>(async (resolve, reject) => {
            Preferences.get({key: storageName + '_' + keyName}).then((res) => {
                if (res && res.value != null) {
                    return resolve((JSON.parse(res.value).val));
                }
                return resolve(defaultValue || false);
            }).catch(() => {
                if (defaultValue !== undefined) {
                    return resolve(defaultValue);
                } else {
                    return reject(1);
                }
            });
        });
    }

    delete(storageName: string, keyName: string): Promise<string> {
        return new Promise(async (resolve) => {
            Preferences.remove({key: storageName + '_' + keyName}).then(() => {
                    resolve('success');
                }
            ).catch(() => resolve('success'));
        });
    }

    getKeys(storageName: string): Promise<string[]> {
        return new Promise(async (resolve) => {
            Preferences.keys().then((keys) => {
                const storageKeys: string[] = [];
                keys.keys.forEach(key => {
                    if (key.includes(storageName + '_')) {
                        storageKeys.push(key.replace(storageName + '_', ''));
                    }
                });
                resolve(storageKeys);
            });
        });
    }

    getAllData(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const object = {};
            try {
                Preferences.keys().then((keys) => {
                    keys.keys.forEach(async key => {
                        const storageName = key.split('_')[0];
                        if (!object[storageName]) {
                            object[storageName] = {};
                        }

                        const keyName = key.replace(storageName + '_', '');
                        object[storageName][keyName] = await this.get(storageName, keyName, undefined);
                    });
                    resolve(object);
                });
            } catch {
                reject('ERROR CREATING JSON OF PREFERENCES');
            }
        });
    }

    deleteDatabase(): Promise<void> {
        return Promise.resolve();
    }
}
